import React, { useState } from 'react'
import SinglePage from '../../components/SinglePage/SinglePage'
import BlogData from '../../data/MarketingBlog/blogData'

function SingleBlogPage() {
  return (
    <>
      <SinglePage />
    </>
  )
}

export default SingleBlogPage
